import { useQuery, useMutation } from "@tanstack/react-query";
import { GetVideoInterviewData, UploadInterviewVideo } from "../infrastructure/videoInterviewService";

export function useVideoInterview(token: string | undefined) {
    return useQuery({
        queryKey: ["videoInterview", token],
        queryFn: () => GetVideoInterviewData(token!),
        enabled: !!token,
        staleTime: 5 * 60 * 1000,
    });
}

export function useUploadVideo(token: string) {
    return useMutation({
        mutationFn: ({ videoBlob, captchaToken }: { videoBlob: Blob; captchaToken?: string }) =>
            UploadInterviewVideo(token, videoBlob, captchaToken),
        onSuccess: () => {
            console.log('Video uploaded successfully');
        },
        onError: (error) => {
            console.error('Video upload failed:', error);
        }
    });
}
